import { render, staticRenderFns } from "./Dictionar.vue?vue&type=template&id=363e19b4"
import script from "./Dictionar.vue?vue&type=script&lang=js"
export * from "./Dictionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports